import React from 'react';
import styled from 'styled-components';
import PropTypes from "prop-types";
import classNames from "classnames";
import RepeatedControl from "../atoms/RepeatedControl";

const CellInner = styled.div`
  width: 100%;
  height: 100%;
`;
function ApplicationOneCells(props) {

  let cells = [];
  for (let i = 0; i < props.xCols.length; i++) {
    for (let j = 0; j < props.yRows.length; j++) {
      const cellClasses = classNames('cell-inner',{
        col1: j % 4 === 0,
        col2: j % 4 === 1,
        col3: j % 4 === 2,
        col4: j % 4 === 3,
        row1: i % 4 === 0,
        row2: i % 4 === 1,
        row3: i % 4 === 2,
        row4: i % 4 === 3,
      })
      cells.push(<CellInner className={cellClasses} key={`${i}-${j}`}>
        <RepeatedControl id={`${i}${j}`} canvas />
      </CellInner>);
    }
  }

  return cells
}

ApplicationOneCells.propTypes = {
  xCols: PropTypes.array.isRequired,
  yRows: PropTypes.array.isRequired,
};

export default ApplicationOneCells;